import { reactive } from 'vue';

/*
    pagination variables are updated when we grab our
    filtered pages in data/results.js
*/
export const pagination = reactive({});

pagination.offset = 0;
pagination.hasNextPage = false;
